import React, { useState } from "react";
import { AppstoreOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { AiFillNotification } from "react-icons/ai";
import { MdLockReset, MdAccountBalance } from "react-icons/md";
import { BsMenuButtonFill } from "react-icons/bs";
import { RiRestaurantFill } from "react-icons/ri";
import { FaPersonBiking, FaSquarePollHorizontal } from "react-icons/fa6";
import { IoMdListBox } from "react-icons/io";
import { FaRegImages, FaUserAlt, FaUsersCog } from "react-icons/fa";
import { IoSettings } from "react-icons/io5";

const Menubar = ({ menubar_Status, onClose }) => {
  const navigate = useNavigate();
  const [stateOpenKeys, setStateOpenKeys] = useState(["2", "23"]);
  const items = [
    {
      key: "1",
      icon: <AppstoreOutlined />,
      label: "Dashboard",
      routes: "/admin",
    },
    {
      key: "2",
      icon: <BsMenuButtonFill />,
      label: "Menu",
      routes: "/admin/menu",
    },
    {
      key: "3",
      icon: <RiRestaurantFill />,
      label: "Restarants",
      routes: "/admin/restaurants",
    },
    {
      key: "16",
      icon: <FaPersonBiking />,
      label: "Drivers",
      routes: "/admin",
    },
    {
      key: "17",
      icon: <IoMdListBox />,
      label: "Orders",
      routes: "/admin/orders",
    },
    {
      key: "18",
      icon: <FaRegImages />,
      label: "Banners",
      routes: "/admin",
    },
    {
      key: "19",
      icon: <AiFillNotification />,
      label: "Promotions",
      routes: "/admin/promotions",
    },
    {
      key: "20",
      icon: <FaUserAlt />,
      label: "Users",
      routes: "/admin/user",
    },
    {
      key: "21",
      icon: <FaUsersCog />,
      label: "Sub Admins",
      routes: "/admin/sub-admin",
    },
    {
      key: "22",
      icon: <FaSquarePollHorizontal />,
      label: "Reports",
      routes: "/admin/reports",
    },
    {
      key: "23",
      icon: <MdAccountBalance />,
      label: "Accounting",
      routes: "/admin/accounts",
    },
    {
      key: "14",
      icon: <IoSettings />,
      label: "Partner",
      routes: "/admin/partner-create",
    },
    {
      key: "15",
      icon: <IoSettings />,
      label: "Settings",
      routes: "/admin",
    },
  ];

  const getLevelKeys = (items1) => {
    const key = {};
    const func = (items2, level = 1) => {
      items2.forEach((item) => {
        if (item.key) {
          key[item.key] = level;
        }
        if (item.children) {
          func(item.children, level + 1);
        }
      });
    };
    func(items1);
    return key;
  };
  const levelKeys = getLevelKeys(items);
  const onOpenChange = (openKeys) => {
    const currentOpenKey = openKeys.find(
      (key) => stateOpenKeys.indexOf(key) === -1
    );
    if (currentOpenKey !== undefined) {
      const repeatIndex = openKeys
        .filter((key) => key !== currentOpenKey)
        .findIndex((key) => levelKeys[key] === levelKeys[currentOpenKey]);
      setStateOpenKeys(
        openKeys
          .filter((_, index) => index !== repeatIndex)
          .filter((key) => levelKeys[key] <= levelKeys[currentOpenKey])
      );
    } else {
      // close
      setStateOpenKeys(openKeys);
    }
  };

  const navigationclick = (value) => {
    const nav_link = value.item.props.routes;
    navigate(`${nav_link}`);
    onClose();
  };

  return (
    <div className="menu_main_container">
      <Menu
        mode="inline"
        expandIcon={menubar_Status === true ? null : ""}
        defaultSelectedKeys={["231"]}
        openKeys={stateOpenKeys}
        onOpenChange={onOpenChange}
        onClick={(e) => navigationclick(e)}
        items={items}
        inlineCollapsed={menubar_Status}
        style={{
          fontWeight: "600",
          fontSize: "0.85rem",
        }}
      />
    </div>
  );
};

export default Menubar;
